/*
 * There are a few apps that will use these action dispatchers,
 * so rather than copy/paste the same code, I'm creating these
 * 'generic' versions that can be used by any app.
 */

import api from 'app/my-schools/api'
import analytics from 'app/analytics/api'

export function AddSchool({onRequest, onError, onSuccess, getIsLoggedIn, onNotLoggedIn}) {
    return function(apiUrl, schoolId) {
        return function (dispatch, getState) {
            const state = getState()
            const isLoggedIn = getIsLoggedIn && getIsLoggedIn(state)

            if(!isLoggedIn) {
                onNotLoggedIn && onNotLoggedIn(dispatch, getState)
                return
            }

            onRequest && onRequest(dispatch, getState, schoolId)

            api.addSchool({
                apiUrl,
                schoolId,
            })
            .then(({statusCode, data}) => {
                if(statusCode !== 200) {
                    onError && onError(dispatch, getState, schoolId, data.errors)
                }
                else {
                    analytics.sendEventAddSchool({schoolId})

                    onSuccess && onSuccess(dispatch, getState, schoolId, data.payload.school)
                }
            })
            .catch(error => {
                onError && onError(dispatch, getState, schoolId, ["Something went wrong and this school could not be added. Please try again."])
            })
        }
    }
}

export function RemoveSchool({onRequest, onError, onSuccess, getIsLoggedIn, onNotLoggedIn}) {
    return function(apiUrl, schoolId) {
        return function (dispatch, getState) {
            const state = getState()
            const isLoggedIn = getIsLoggedIn && getIsLoggedIn(state)

            if(!isLoggedIn) {
                onNotLoggedIn && onNotLoggedIn(dispatch, getState)
                return
            }

            onRequest && onRequest(dispatch, getState, schoolId)

            api.removeSchool({
                apiUrl,
                schoolId,
            })
            .then(({statusCode, data}) => {
                if(statusCode !== 200) {
                    onError && onError(dispatch, getState, schoolId, data.errors)
                }
                else {
                    analytics.sendEventRemoveSchool({schoolId})

                    onSuccess && onSuccess(dispatch, getState, schoolId, data.payload.school)
                }
            })
            .catch(error => onError && onError(dispatch, getState, schoolId, ["Something went wrong and this school could not be removed. Please try again."]))
        }
    }
}

export function GetSchools({onRequest, onError, onSuccess}) {
    return function(apiUrl) {
        return function (dispatch, getState) {
            onRequest && onRequest(dispatch, getState)

            api.getSchools({
                apiUrl,
            })
            .then(({statusCode, data}) => {
                if(statusCode !== 200) {
                    onError && onError(dispatch, getState, data.errors)
                }
                else {
                    onSuccess && onSuccess(dispatch, getState, data.payload.schools)
                }
            })
            .catch(error => {
                onError && onError(dispatch, getState, ["Something went wrong and your schools could not be fetched."])
            })
        }
    }
}



// WEBPACK FOOTER //
// ./react/my-schools/actions/generics.js